import { countryPhoneDigitLimits } from "constants";
import * as Yup from "yup";

export const ValidationUtils = {
  form: async (values, schema, contextData) => {
    try {
      // Support both old API (selectedCountryCode directly) and new API (context object)
      const context = contextData?.selectedCountryCode
        ? contextData
        : { selectedCountryCode: contextData };

      await schema.validate(values, {
        abortEarly: false,
        context,
      });
      return { isValid: true };
    } catch (err) {
      let errMessages = {};
      if (err instanceof Yup.ValidationError) {
        err.inner?.forEach((error) => {
          const path = error?.path;
          if (path.includes(".")) {
            const secondPart = path.split(".")[1];
            errMessages[secondPart] = error?.message;
          } else {
            errMessages[error?.path] = error?.message;
          }
        });
      }
      return { errMessages, isValid: false };
    }
  },
  phoneNumber: (value, countryCode) => {
    if (!value || !countryCode) return false;

    const phoneNumber = value.includes("_") ? value.split("_")[1] : value;
    if (!/^[0-9]+$/.test(phoneNumber)) return false;

    const limit = countryPhoneDigitLimits[countryCode];

    if (Array.isArray(limit)) return limit.includes(phoneNumber.length);
    return phoneNumber.length === limit;
  },
};
